import React from 'react';
import { ResetPasswordRequestForm } from '../../components/Form/Password';
import { CommonResetPassword } from './CommonResetPassword';

export const ResetPasswordRequest: React.FC = () => (
  <CommonResetPassword title="resetPasswordRequest">
    <ResetPasswordRequestForm />
  </CommonResetPassword>
);
